import StatusBadge from '../StatusBadge';
import { StatusTimeline } from '../StatusTimeline';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { requestTheme } from '../../utils/requestTheme';

export function InternalDetailDialog({ selectedInternalRequest, setShowInternalDetail, showInternalDetail, user }) {
  const isOps = selectedInternalRequest?.category === 'operasional';
  const theme = requestTheme(selectedInternalRequest?.category);
  return (
    <Dialog open={showInternalDetail} onOpenChange={setShowInternalDetail}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span className={`px-1.5 py-0.5 rounded text-xs font-bold ${theme.badge}`}>{theme.code}</span>
            Detail {theme.label} Payment Request
          </DialogTitle>
          <p className="text-sm text-slate-600">Informasi lengkap payment request dari user {theme.label}</p>
        </DialogHeader>
        {selectedInternalRequest && (
          <div className="space-y-4">
            <StatusTimeline docType="internal_payment_request" docId={selectedInternalRequest.id} fallbackDates={[{ label: 'Dibuat', at: selectedInternalRequest.created_at, by: selectedInternalRequest.created_by_name }, { label: 'Disetujui/ditolak', at: selectedInternalRequest.approved_at, by: selectedInternalRequest.approved_by_name }, { label: 'Terbayar', at: selectedInternalRequest.paid_at }]} />
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-slate-600">Request Number</p>
                <p className="font-mono font-semibold">{selectedInternalRequest.request_number}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Tipe Request</p>
                <p className="font-semibold">{selectedInternalRequest.tipe_request}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Perusahaan</p>
                {selectedInternalRequest.company_name
                  ? <p className="font-semibold">{selectedInternalRequest.company_name}</p>
                  : <p className="font-semibold text-[#800000]">Belum diisi</p>}
              </div>
              <div>
                <p className="text-sm text-slate-600">Departemen</p>
                <p className="font-semibold" data-testid="detail-departemen">{selectedInternalRequest.departemen_nama || '-'}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Status</p>
                <StatusBadge status={selectedInternalRequest.status} />
              </div>
              <div className="col-span-2">
                <p className="text-sm text-slate-600">Amount</p>
                <p className="font-mono font-semibold text-lg">Rp {selectedInternalRequest.amount?.toLocaleString('id-ID')}</p>
              </div>
            </div>

            {/* Data Penerima */}
            <div className={isOps ? 'bg-[#fbeaea] p-4 rounded-lg border border-[#e8bcbc]' : 'bg-purple-50 p-4 rounded-lg border border-purple-200'}>
              <p className={`text-sm font-semibold mb-3 ${isOps ? 'text-[#800000]' : 'text-purple-700'}`}>Data Penerima{isOps ? ' (diisi manual)' : ''}</p>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div>
                  <p className="text-slate-500">Nama</p>
                  <p className="font-semibold">{selectedInternalRequest.penerima_nama}</p>
                </div>
                <div>
                  <p className="text-slate-500">Email</p>
                  <p className="font-semibold">{selectedInternalRequest.penerima_email || '-'}</p>
                </div>
                <div>
                  <p className="text-slate-500">No. Rekening</p>
                  <p className="font-mono font-semibold">{selectedInternalRequest.penerima_rekening || '-'}</p>
                </div>
                <div>
                  <p className="text-slate-500">Nama Bank</p>
                  <p className="font-semibold">{selectedInternalRequest.penerima_bank || '-'}</p>
                </div>
                <div>
                  <p className="text-slate-500">No. WA</p>
                  <p className="font-semibold">{selectedInternalRequest.penerima_wa || '-'}</p>
                </div>
              </div>
            </div>

            <div>
              <p className="text-sm text-slate-600">Requested By</p>
              <p className="font-semibold">{selectedInternalRequest.created_by_name}</p>
              <p className="text-xs text-slate-500">
                {selectedInternalRequest.created_at && new Date(selectedInternalRequest.created_at).toLocaleString('id-ID')}
              </p>
            </div>

            {selectedInternalRequest.approved_by_name && (
              <div>
                <p className="text-sm text-slate-600">Approved/Rejected By</p>
                <p className="font-semibold">{selectedInternalRequest.approved_by_name}</p>
              </div>
            )}

            {selectedInternalRequest.rejection_reason && (
              <div className="bg-rose-50 p-4 rounded-lg border border-rose-200">
                <p className="text-sm font-semibold text-rose-700">Alasan Penolakan</p>
                <p className="text-sm text-rose-900">{selectedInternalRequest.rejection_reason}</p>
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
